/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { observer } from "mobx-react";
import { checkTeamSubscriptionActive } from "Utils/commonAPI";
import UpgradeIconTooltip from "Components/Paywall/UpgradeIconTooltip";
import userDetail from "Stores/userDetail";
import CustomTooltip from "Components/common/CustomTooltip";
import PaywallUtils from "Utils/PaywallUtils";
import Utils from "Utils/utils";
import EnrichPopup from "Components/common/EnrichPopup";
import { ReactComponent as EnrichIcon } from "Assets/svg/Enrich/enrich.svg";

/**
 * "Enrich" toolbar button. Clicking it opens the Enrich popup, where the user picks
 * which steps to run (profile / emails / phones); the popup calls `cbk` with the
 * enrichContactPayload ({ enrichType, profile }) for /cm/bulk/perform.
 *
 * `getPreviewPayload` must return the same {search, filter, totalCount} the run
 * will send, so the popup's counts match what actually gets enriched.
 */
const EnrichBtn = props => {
  const {
    selectedEntityCount = 0,
    cbk = () => {},
    getPreviewPayload = () => ({}),
    onToolkitSubmit = null,
    loading = false,
    checked = false,
    pageType = "",
    isEnrichEnabled = true,
    showTooltip = false,
    text = ""
  } = props || {};

  const { inFreePlan = false, planName = "" } =
    userDetail.userFeatureFlag || {};
  const [showDescriptionTp, setShowDescriptionTp] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  if (Utils.isSalesIntelHost()) return null;

  const openPopup = async () => {
    setShowDescriptionTp(false);
    if (
      selectedEntityCount > 0 &&
      checked &&
      !loading &&
      isEnrichEnabled &&
      (await checkTeamSubscriptionActive())
    ) {
      setShowPopup(true);
    }
  };

  const handleSubmit = async enrichContactPayload => {
    setShowPopup(false);
    await cbk(enrichContactPayload);
  };

  const handleToolkitSubmit = async request => {
    setShowPopup(false);
    await onToolkitSubmit(request);
  };

  const pageTypeObj = {
    calls: "callsExport",
    contacts: "contactsExport",
    sequences: "sequenceExport"
  };

  return (
    <>
      <div
        className={`exportBtnWrapper enrichBtnwrapper ${
          selectedEntityCount <= 0 ? "exportSelectedDisabled" : ""
        } ${selectedEntityCount ? "enabled" : ""}`}
        onMouseEnter={() => showTooltip && setShowDescriptionTp(true)}
        onMouseLeave={() => setShowDescriptionTp(false)}
        onClick={openPopup}
      >
        <span className="enrichText">
          <EnrichIcon />
        </span>
        {text && (
          <span className={`text ${selectedEntityCount > 0 ? "active" : ""}`}>
            {text}
          </span>
        )}
        {!isEnrichEnabled && (
          <span className="wrapLockIcon">
            <UpgradeIconTooltip
              plan={PaywallUtils.getPlanName(planName, inFreePlan)}
              type={pageTypeObj[pageType]}
              enableTooltip={true}
              alignTooltip="topRight"
            />
          </span>
        )}
        {showDescriptionTp && (
          <CustomTooltip
            text={
              selectedEntityCount > 0
                ? "Enrich selected"
                : "Select one or more contacts to enrich."
            }
            className={
              selectedEntityCount > 0
                ? "enrichContactsTooltip"
                : "bulkAddtoSequence"
            }
          />
        )}
      </div>
      {showPopup && (
        <EnrichPopup
          selectedCount={selectedEntityCount}
          getPreviewPayload={getPreviewPayload}
          onSubmit={handleSubmit}
          onToolkitSubmit={typeof onToolkitSubmit === "function" ? handleToolkitSubmit : null}
          onClose={() => setShowPopup(false)}
        />
      )}
    </>
  );
};

export { EnrichBtn };
export default observer(EnrichBtn);
